'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkSkuCategoryPageHero.module.css';

export function DevlinkSkuCategoryPageHero({
  as: _Component = _Builtin.Section,
  skuCategoryName = 'SKU Category Name',
  showCategoryImage = true,
  skuCategoryImage = 'https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/61d875a821307773e9b3e372_tv-mounting.png',
  showImageSlot = false,
  imageSlot,
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'overflow-hidden')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'medium')} tag="div" />
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Image
          className={_utils.cx(_styles, 'cat--hero-bean')}
          loading="eager"
          width="auto"
          height="auto"
          alt=""
          src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/61d8765949fd9b56b2a5479f_teal-bean.png"
        />
        <_Builtin.Block className={_utils.cx(_styles, 'ht-column-block', 'switch-on-mobile')} tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-column-block-content')} tag="div">
            <_Builtin.Heading className={_utils.cx(_styles, 'txt-title')} tag="h1">
              {skuCategoryName}
            </_Builtin.Heading>
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'ht-column-block-img', 'height-auto')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-sku-cat-hero-img')} tag="div">
              {showImageSlot ? (
                <_Builtin.Block className={_utils.cx(_styles, 'ht-image-slot')} tag="div">
                  {imageSlot}
                </_Builtin.Block>
              ) : null}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
